export default "__VITE_ASSET__ByiSOOP5__"